import { FlatList, Pressable, StyleSheet, View, type ListRenderItemInfo } from 'react-native';
import type { WrongQuestionFilterViewModel } from '../../types/wrongQuestions';
import { tokens } from '../../theme/tokens';
import { AppText } from '../ui/AppText';

type WrongQuestionFilterBarProps = {
  filters: WrongQuestionFilterViewModel[];
  activeFilterId: string;
  onChangeFilter: (filterId: string) => void;
};

export function WrongQuestionFilterBar({
  filters,
  activeFilterId,
  onChangeFilter,
}: WrongQuestionFilterBarProps) {
  const renderFilter = ({ item }: ListRenderItemInfo<WrongQuestionFilterViewModel>) => {
    const active = item.id === activeFilterId;
    return (
      <Pressable
        accessibilityRole="button"
        onPress={() => onChangeFilter(item.id)}
        style={({ pressed }) => [
          styles.filterChip,
          active ? styles.filterChipActive : null,
          pressed ? styles.pressed : null,
        ]}
      >
        <AppText
          variant="caption"
          weight="bold"
          tone={active ? 'primary' : 'muted'}
        >
          {item.label}
        </AppText>
      </Pressable>
    );
  };

  return (
    <FlatList
      horizontal
      data={filters}
      keyExtractor={(item) => item.id}
      renderItem={renderFilter}
      showsHorizontalScrollIndicator={false}
      ItemSeparatorComponent={Separator}
      contentContainerStyle={styles.content}
    />
  );
}

function Separator() {
  return <View style={styles.separator} />;
}

const styles = StyleSheet.create({
  content: {
    paddingVertical: tokens.spacing.xs,
  },
  filterChip: {
    minHeight: 36,
    borderRadius: tokens.radius.full,
    borderWidth: tokens.border.width,
    borderColor: tokens.colors.border,
    backgroundColor: tokens.colors.surface,
    justifyContent: 'center',
    paddingHorizontal: tokens.spacing.md,
  },
  filterChipActive: {
    borderColor: tokens.colors.primary,
    backgroundColor: tokens.colors.surfaceMuted,
  },
  pressed: {
    opacity: 0.86,
  },
  separator: {
    width: tokens.spacing.sm,
  },
});
